// Third Party Imports
import React from 'react';

// HA Artifactory Imports
import {FormInput} from '@homeaway/react-form-components';
import {InlineMessage} from '@homeaway/react-alerts';

// Relative Imports
import './PropertyCount.less';
import ContinueButtonHolder from '../ButtonHolder/ContinueButtonHolder';
import {processTranslation} from '../utils/commonUtil';
import {isPPM, isSWSwitchIPM} from '../../utils/validate';
import SubHead from '../SubHead/SubHead';
import AlertBox from '../Alert/Alert';

export default class PropertyCount extends React.Component {
    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }

    getListContent(descList) {
        const response = [];
        for (const [i, item] of descList.entries()) {
            if (item) {
                response.push(<li key={i} className="sub-head-grey">{item}</li>);
            }
        }

        return response;
    }

    getPropertyCountContent = (userType, translations) => {
        const propertyCountContent = {};
        if (isPPM(userType)) {
            propertyCountContent.head = translations['ipmob.ppm.property_count.heading'];
            propertyCountContent.subHead = translations['ipmob.ppm.property_count.sub_heading'];
            propertyCountContent.desc = [translations['ipmob.property_count.content_1'], translations['ipmob.property_count.content_2'], translations['ipmob.ppm.property_count.content_3']];
            propertyCountContent.fieldLabel = translations['ipmob.ppm.property_count.label'];
            propertyCountContent.infoMessage = translations['ipmob.ppm.property_count.info_message'];
        } else if (isSWSwitchIPM(userType)) {
            propertyCountContent.head = translations['ipmob.property_count.heading'];
            propertyCountContent.subHead = translations['ipmob.property_count.sub_heading'];
            propertyCountContent.desc = [translations['ipmob.property_count.content_1'], translations['ipmob.property_count.content_2'], translations['ipmob.property_count.content_3']];
            propertyCountContent.fieldLabel = translations['ipmob.property_count.label'];
        } else {
            propertyCountContent.head = translations['ipmob.property_count.heading'];
            propertyCountContent.subHead = translations['ipmob.property_count.sub_heading'];
            propertyCountContent.desc = [translations['ipmob.property_count.content_1'], translations['ipmob.property_count.content_2']];
            propertyCountContent.fieldLabel = translations['ipmob.property_count.label'];
        }

        return propertyCountContent;
    };

    render() {
        const {
            translations,
            handleContinueButtonClick,
            handleBackButtonClick,
            triggerEdapEvent,
            handlePropertyCountChange,
            numberOfProperty,
            propertyCountError,
            triggerEdapEventOnFocus,
            onPropertyCountBlur,
            enableContinueButton,
            userType,
            liveListingCount,
            serviceError,
            handleAlertDismiss,

            handleSaveAndFinishOnClick,
            isSaveModalOpen,
            handleSaveModalClose
        } = this.props;

        const propertyCountContent = this.getPropertyCountContent(userType, translations);

        return (<div id="propertyCount" className="property-count">
            <div className={`property-count-container ${isPPM(userType) ? null : 'pc-subhead'}`}>
                {
                    (isPPM(userType) || isSWSwitchIPM(userType))
                        ?
                        <SubHead
                            translations={translations}
                            handleSaveAndFinishOnClick={handleSaveAndFinishOnClick}
                            isSaveModalOpen={isSaveModalOpen}
                            handleSaveModalClose={handleSaveModalClose}
                        />
                        : null
                }

                {
                    (serviceError)
                        ? <div className="alert-panel">
                            <AlertBox
                                messageKey={serviceError}
                                translations={translations}
                                handleAlertDismiss={handleAlertDismiss}
                                size={'sm'}
                            />
                        </div>
                        : null
                }
                <div className="wrapper">
                    <div className="content-col-text panel-head">
                        <h1 className="head">{propertyCountContent.head}</h1>
                    </div>
                </div>
                <div className="wrapper">
                    <div className="content-col-sub-text panel-head">
                        <span className="sub-head-grey">{propertyCountContent.subHead}</span>
                        <ul className="sub-head-holder">{this.getListContent(propertyCountContent.desc)}</ul>
                    </div>
                </div>
                <form role="form" onSubmit={handleContinueButtonClick}>
                    <div className="input-container" aria-label="Big form">
                        <div className="wrapper">
                            <div className="content-col">
                                <FormInput
                                    id="noOfProperties"
                                    type="text"
                                    name="Number of properties"
                                    label={propertyCountContent.fieldLabel}
                                    value={numberOfProperty}
                                    onChange={handlePropertyCountChange}
                                    errorMsg={translations[propertyCountError]}
                                    onFocus={triggerEdapEventOnFocus}
                                    onBlur={onPropertyCountBlur}
                                    maxLength="6"
                                />
                                {
                                    (propertyCountContent.infoMessage)
                                        ? <InlineMessage
                                                type={'info'}
                                                message={processTranslation(propertyCountContent.infoMessage, [liveListingCount])}
                                                id="pcInputInlineMessage"
                                                marginTop={-7}
                                                marginBottom={15}
                                          />
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                </form>
                <ContinueButtonHolder
                    enableContinueButton={enableContinueButton}
                    handleContinueButtonClick={handleContinueButtonClick}
                    translations={translations}
                    continueButtonId={'propertyCountContinueBtn'}
                    triggerEdapEvent={triggerEdapEvent}
                    enableBackButton={(userType === 'IPM')}
                    handleBackButtonClick={handleBackButtonClick}
                />
            </div>
        </div>);
    }
}
